import { useTranslation } from "react-i18next"

function LoaderSmall() {
    const { t } = useTranslation();
    return (
        <div className='loader'>
            <div>
                <div className="loader-icon-sm mt-4">
                </div>
                <h5>{t("loading-span")}</h5>
            </div>
        </div>
    )
}
export default LoaderSmall